/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response light for a patient
 * @export
 * @interface SearchPatientResponse
 */
export interface SearchPatientResponse {
    /**
     * Unique identifier of the patient
     * @type {string}
     * @memberof SearchPatientResponse
     */
    personWithRoleId?: string;
    /**
     * Firstname of patient
     * @type {string}
     * @memberof SearchPatientResponse
     */
    firstName?: string;
    /**
     * Lastname of patient
     * @type {string}
     * @memberof SearchPatientResponse
     */
    lastName?: string;
    /**
     * Unique identifier of the patient
     * @type {string}
     * @memberof SearchPatientResponse
     */
    relationShipId?: string;
    /**
     * CNS number
     * @type {string}
     * @memberof SearchPatientResponse
     */
    cnsAffiliationNumber?: string;
    /**
     * the birthdate of the patient
     * @type {string}
     * @memberof SearchPatientResponse
     */
    birthDate?: string;
}

/**
 * Check if a given object implements the SearchPatientResponse interface.
 */
export function instanceOfSearchPatientResponse(value: object): value is SearchPatientResponse {
    return true;
}

export function SearchPatientResponseFromJSON(json: any): SearchPatientResponse {
    return SearchPatientResponseFromJSONTyped(json, false);
}

export function SearchPatientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPatientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'personWithRoleId': json['personWithRoleId'] == null ? undefined : json['personWithRoleId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'relationShipId': json['relationShipId'] == null ? undefined : json['relationShipId'],
        'cnsAffiliationNumber': json['cnsAffiliationNumber'] == null ? undefined : json['cnsAffiliationNumber'],
        'birthDate': json['birthDate'] == null ? undefined : json['birthDate'],
    };
}

export function SearchPatientResponseToJSON(json: any): SearchPatientResponse {
    return SearchPatientResponseToJSONTyped(json, false);
}

export function SearchPatientResponseToJSONTyped(value?: SearchPatientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personWithRoleId': value['personWithRoleId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'relationShipId': value['relationShipId'],
        'cnsAffiliationNumber': value['cnsAffiliationNumber'],
        'birthDate': value['birthDate'],
    };
}

